/**
 * Central API endpoint paths. Use in api/*.js modules with serviceClient / getApiClient.
 * Functions return path + optional query string so URLs stay in one place.
 */
export const ENDPOINTS = {
  OBJECTS: {
    RECENT: () => "api/DocumentManagement/get-recentobjects",
  },
    CHECKIN: {
    DOCUMENT: () => "api/DocumentManagement/check-in",
    DOCUMENT_CHUNKED: () => "api/DocumentManagement/check-in/upload",
    DOCUMENTS_BULK: () => "api/DocumentManagement/check-in/check-in-bulk",
  },
  /** OneDrive/Teams document list (check-in new list, working docs list). */
  ONEDRIVE: {
    DOCS: () => "api/OneDrive/get-onedrive-docs",
  },
  DOCUMENTS: {
    SEARCH: () => "api/search-documents",
    RECENT: () => "api/get-recent-documents",
    MERGE_EXPORT: () => "api/merge-export-documents",
  },
  CHANNEL: {
    CONFIGS: () => "api/Channel/get-channel-configs",
  },
  AUTH: {
    CUSTOMER_CONFIG: () => "api/Customer/get-customerconfig",
  },
};
